import { IAutoCompletePrefix } from "api/interfaces/search.type";
import axios from "../../fetch-api/fetch-api";

export function getPrefixSearchAutocompleteApi(prefix: string, fuzzy = false, context = "all", extraParams) {
  return axios
    .get<IAutoCompletePrefix[]>(`${process.env.NEXT_PUBLIC_ROOT_URL}/search/prefix-search-autocomplete-v3`, {
      params: {
        prefix,
        context,
        fuzzy,
        ...extraParams,
      },
    });
}
